
const floor = Math.floor

export function difference(data: Float32Array) {
    const n = data.length
    const results = new Float32Array(n)
    let difference: number;
    let summation: number;
    for (var tau = 0, windowSize = floor(n * 0.5); tau <= windowSize; tau++) {
        summation = 0
        for (let j = 0; j < windowSize; j++) {
            difference = data[j] - data[j + tau]
            summation += difference * difference
        }
        results[tau] = summation
    }
    return results
}

export function cumulativeMeanNormalizedDifference(data: Float32Array) {
    const n = data.length
    const results = new Float32Array(n)
    let summation: number;

    for (var tau = 0; tau < n; tau++) {
        summation = 0
        for (var j = 0; j <= tau; j++) {
            summation += data[j]
        }
        results[tau] = data[tau] / (summation / tau)
    }
    return results
}

export function absoluteThreshold(data: Float32Array, threshold: number) {
    var x: number;
    var k = Number.POSITIVE_INFINITY
    var tau: number;

    for (var i = 0, n = data.length; i < n; i++) {
        x = data[i]
        if (x < threshold) {
            return i
        }
        if (x < k) {
            k = x
            tau = i
        }
    }
    return tau
}

export function bestLocalEstimate(data: Float32Array, tau: number) {
    let i = tau + 1
    const n = data.length
    let k = data[tau]
    while (i < n && data[i] < k) {
        k = data[i]
        i++
    }
    return i - 1
}


export function easeInOut(exp = Math.PI / 2) {
    return t => Math.pow(t, exp) / (Math.pow(t, exp) + Math.pow(1 - t, exp));
}

export function accelerate(exp = 2) {
    return t => Math.pow(t, exp);
}

export function linear() {
    return t => t;
}